<script>
  import ChannelsListItem from './ChannelsListItem'

  export default {
    name: 'channels-list',

    components: {
      ChannelsListItem
    },

    props: {
      channels: {
        type: Array,
        required: true
      }
    }
  }
</script>

<template>
  <table class="table table-hive">
    <thead>
    <tr>
      <th scope="col" style="width: 45%;">
        <h5>My Channels <span v-if="channels.length">({{ channels.length }})</span></h5>
      </th>
      <th scope="col">Zones</th>
      <th scope="col" style="width: 10%;">Last Edited</th>
      <th scope="col"></th>
    </tr>
    </thead>
    <transition-group name="list" tag="tbody">
      <channels-list-item v-for="channel in channels" :key="channel.channelId" :channel="channel"/>
    </transition-group>
  </table>
</template>

<style src="./ChannelsList.scss" lang="scss" scoped></style>
